import { render } from "./Page.vue?vue&type=template&id=62b36058"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

import "./Page.vue?vue&type=style&index=0&id=62b36058&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Views/Content/Page.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62b36058"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62b36058', __exports__)) {
    api.reload('62b36058', __exports__)
  }
  
  module.hot.accept("./Page.vue?vue&type=template&id=62b36058", () => {
    api.rerender('62b36058', render)
  })

}


export default __exports__